import * as React from 'react';
import Strings from '../../globals/Strings';

export default ({numberReviewers}: AvatarStackProps) => {
   const titleString = Strings.labels.additionalReviewers.replace('{param0}', numberReviewers.toString());

   return (
      <div className="avatar" >
         <span title={titleString} className="avatar avatar-stack">
            +{numberReviewers}
         </span>
      </div>
   );
};

export interface AvatarStackProps {
   numberReviewers: number;
}
